@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(1_853_863_809)
internal val Res.font.bricolage_grotesque_bold: FontResource by lazy {
      FontResource("font:bricolage_grotesque_bold", setOf(
        ResourceItem(setOf(), "${MD}font/bricolage_grotesque_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_125_647_662)
internal val Res.font.bricolage_grotesque_extrabold: FontResource by lazy {
      FontResource("font:bricolage_grotesque_extrabold", setOf(
        ResourceItem(setOf(), "${MD}font/bricolage_grotesque_extrabold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(694_836_214)
internal val Res.font.geist_bold: FontResource by lazy {
      FontResource("font:geist_bold", setOf(
        ResourceItem(setOf(), "${MD}font/geist_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(218_312_360)
internal val Res.font.geist_medium: FontResource by lazy {
      FontResource("font:geist_medium", setOf(
        ResourceItem(setOf(), "${MD}font/geist_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_484_110_140)
internal val Res.font.geist_regular: FontResource by lazy {
      FontResource("font:geist_regular", setOf(
        ResourceItem(setOf(), "${MD}font/geist_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(353_741_537)
internal val Res.font.geist_semibold: FontResource by lazy {
      FontResource("font:geist_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/geist_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("bricolage_grotesque_bold", Res.font.bricolage_grotesque_bold)
  map.put("bricolage_grotesque_extrabold", Res.font.bricolage_grotesque_extrabold)
  map.put("geist_bold", Res.font.geist_bold)
  map.put("geist_medium", Res.font.geist_medium)
  map.put("geist_regular", Res.font.geist_regular)
  map.put("geist_semibold", Res.font.geist_semibold)
}
